import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import Carousel from "../../atoms/carousel";
import Icon from "../../atoms/icon";
import assetify from "@quintype/framework/assetify";
import win from "../../../../assets/images/win.png";
import BigSliderSlide from "../../atoms/big-slider-slide/index";
import styles from "./styles.m.css";
import { fetchAllCandidatesList } from "../../../api";

const StarCandidateResult = ({
  accentColor,
  numberOfCardsInViewDesktop = 4,
  numberOfCardsInViewTablet = 2,
  numberOfCardsInViewMobile = 1
}) => {
  const [constituency, setConstituency] = useState([]);
  const desktopGap = 30;
  const mobileGap = 0;
  useEffect(() => {
    fetchAllCandidatesList()
      .then(res => {
        const conRes = get(res, ["data", "items"]);
        setConstituency(conRes);
      })
      .catch(console.error);
  }, []);

  const candidateList = constituency.filter(item => item.election_result_home === 1);

  let slides =
    candidateList.length !== 0 &&
    candidateList.map((item, index) => (
      <div className={styles["box-div"]} key={"slide-" + index}>
        <div className={styles["title"]}>
          <h1>{item.party_name}</h1>
        </div>
        <div className={styles["other-img"]}>
          <img src={`${item.candidate_image}`} className={styles["mem-img"]} />
          <h1 className={styles["canditate-name"]}>{item.candidate_name}</h1>
        </div>
        <img alt="Vikatan" src={assetify(win)} className={styles["result"]} />
      </div>
    ));

  return (
    <div className={`${styles["base"]}`} style={accentColor && { "--accent-color": accentColor }}>
      <div className={`container`}>
        <div className={styles["star-canditate-wrapper"]}>
          <h1 className={styles["star-title"]}>நட்சத்திர வேட்பாளர்கள் </h1>
          {candidateList.length !== 0 && (
            <Carousel
              className={styles["carousel"]}
              options={{
                type: "carousel",
                perView: numberOfCardsInViewDesktop,
                gap: desktopGap,
                rewind: false,
                peek: {
                  before: 0,
                  after: 244
                },
                breakpoints: {
                  767: {
                    perView: numberOfCardsInViewMobile,
                    gap: mobileGap,
                    peek: {
                      before: mobileGap,
                      after: 144
                    }
                  },
                  991: {
                    perView: numberOfCardsInViewTablet,
                    gap: desktopGap,
                    peek: {
                      before: desktopGap,
                      after: 244
                    }
                  }
                }
              }}
              renderCenterLeftControls={({ previousSlide, currentSlide }) =>
                currentSlide > 0 ? (
                  <button
                    aria-label="previous slide"
                    role="button"
                    onClick={previousSlide}
                    className={`${styles["slider-nav-button"]}`}
                  >
                    <Icon type="angle-left" className={styles.icon} />
                  </button>
                ) : null
              }
              renderCenterRightControls={({ nextSlide }) => (
                <button
                  aria-label="next slide"
                  role="button"
                  onClick={nextSlide}
                  className={`${styles["slider-nav-button"]}`}
                >
                  <Icon type="angle-right" className={styles.icon} />
                </button>
              )}
              childClass={styles["glide_li"]}
            >
              {slides}
            </Carousel>
          )}
          <div className={`${styles["read-more"]}`}>
            <a href="#" className={`${styles["read-more-link"]}`}>
              மேலும் படிக்க
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

StarCandidateResult.propTypes = {
  accentColor: PropTypes.string,
  numberOfCardsInViewDesktop: PropTypes.number,
  numberOfCardsInViewTablet: PropTypes.number,
  numberOfCardsInViewMobile: PropTypes.number,
  stories: PropTypes.arrayOf(BigSliderSlide.propTypes.story)
};

export default StarCandidateResult;
